import NiceModal from "@ebay/nice-modal-react";
import EditTagEventModal from "../../../components/dataOperationModals/editTagEventModal/EditTagEventModal";
import { DataOperation, VizContext } from "./DataOperation";

export class CreateTagEventDataOperation extends DataOperation {
    constructor() {
        super();
        this.operationId = "createTagEvent";
        this.displayName = "Create Tag Event";
        this.icon = {
            type: "image",
            lightUrl: "/images/icons/tag-add-object_56.png",
            darkUrl: "/images/icons/dark-tag-add-object_56.png",
        };
        this.priority = "primary";
        this.context = "global";
        this.category = "tags";
        NiceModal.register(this.operationId, EditTagEventModal);
    }

    canExecute(context: VizContext) {
        return context?.view?.data.hasAssociatedMedia && context.view.data.state == "loaded";
    }

    execute(context: VizContext) {
        NiceModal.show(this.operationId, { context });
    }
}
